import script from "./FightEstimatedTime.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./FightEstimatedTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./FightEstimatedTime.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./FightEstimatedTime.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__